"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**Crea una nueva promesa y devuelve por separado la promesa y las funciones que resuelven y rechazan a la promesa */
function splitPromise() {
    var resolve = null;
    var reject = null;
    var promise = new Promise(function (promResolve, promReject) {
        resolve = promResolve;
        reject = promReject;
    });
    return { promise: promise, resolve: resolve, reject: reject };
}
exports.splitPromise = splitPromise;
//# sourceMappingURL=async.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-modal-manager/dist/async.js
// module id = 2483
// module chunks = 0